export enum GtmEvent {
    virtual_page_view = 'virtual_page_view',
    setup_guide_step_done = 'setup_guide_step_done',
    help_center_clicked = 'help_center_clicked',
    banner_action_clicked = 'banner_action_clicked',
}
